let _newsGraphOriginalTitleAndDateParent = null;
let _newsGraphOriginalTitleAndDateNextSibling = null;
let _newsGraphActiveFilter = null;
let _newsGraphActiveMode = '3d';
let _newsGraphLastData = null;
let _newsGraphOnNodeClick = null;
let _newsGraphSphereVisible = true;

const getNewsGraphTargetElements = () => [
    document.querySelector('.filters-container'),
    document.querySelector('.fullscreen-toggle'),
    document.querySelector('.main-controls'),
    document.querySelector('.bottom-player-area')
];


window.exitNewsGraphMode = function(restoreFilter = false, skipTickerNewsReset = false) {
    document.body.classList.remove('news-graph-active');
    const isNewsGraphActive = !!window._newsGraphInstance;

    if (window._newsGraphInstance) {
        window._newsGraphInstance.destroy();
        window._newsGraphInstance = null;
    }

    const elementsToRestore = getNewsGraphTargetElements();
    
    elementsToRestore.forEach(el => {
        if (el && el.dataset.newsGraphHidden === 'true') {
            el.style.display = el.dataset.oldDisplay || '';
            delete el.dataset.newsGraphHidden;
            delete el.dataset.oldDisplay;
        }
    });

    const titleAndDate = document.querySelector('.title-and-date');
    if (titleAndDate && _newsGraphOriginalTitleAndDateParent) {
        if (_newsGraphOriginalTitleAndDateNextSibling && _newsGraphOriginalTitleAndDateNextSibling.parentNode === _newsGraphOriginalTitleAndDateParent) {
            _newsGraphOriginalTitleAndDateParent.insertBefore(titleAndDate, _newsGraphOriginalTitleAndDateNextSibling);
        } else {
            _newsGraphOriginalTitleAndDateParent.appendChild(titleAndDate);
        }
        _newsGraphOriginalTitleAndDateParent = null;
        _newsGraphOriginalTitleAndDateNextSibling = null;
    }

    const closeBtn = document.querySelector('#news-graph-close-btn');
    if (closeBtn) {
        closeBtn.remove();
    }

    const legend = document.getElementById('news-graph-legend');
    if (legend) legend.style.display = 'none';

    const toolbar = document.getElementById('news-graph-toolbar');
    if (toolbar) toolbar.style.display = 'none';
    const btnLegend = document.getElementById('ng-btn-legend');
    if (btnLegend) btnLegend.classList.remove('active');
    const btnRotate = document.getElementById('ng-btn-rotate');
    if (btnRotate) btnRotate.classList.remove('active');
    const btnGlobe = document.getElementById('ng-btn-globe');
    if (btnGlobe) btnGlobe.classList.remove('active');
    const btn3d = document.getElementById('ng-btn-3d');
    if (btn3d) btn3d.classList.add('active');
    const btn2d = document.getElementById('ng-btn-2d');
    if (btn2d) btn2d.classList.remove('active');
    _newsGraphActiveMode = '3d';
    _newsGraphSphereVisible = true;



    const newsMenuBtn = document.getElementById('ss-news-btn');
    if (newsMenuBtn) newsMenuBtn.classList.remove('active');

    if (restoreFilter && isNewsGraphActive) {
        const targetBtn = _newsGraphActiveFilter
            || document.querySelector('.filters-container .item[data-action="topdollar"]');
        if (targetBtn) {
            document.querySelectorAll('.filters-container .item').forEach(b => b.classList.remove('active'));
            targetBtn.classList.add('active');
        }

        const stockCubeEl = document.querySelector('[stock-cube-visualizer]');
        const stockCubeComp = stockCubeEl && stockCubeEl.components && stockCubeEl.components['stock-cube-visualizer'];
        if (stockCubeComp && stockCubeComp.currentData) {
            try {
                stockCubeComp.renderFinalFrame(stockCubeComp.currentData);
            } catch (e) {}
        } else if (targetBtn) {
            targetBtn.click();
        }
    }

    const ctrl = _getExistingTickerNewsComponent();
    if (ctrl && isNewsGraphActive && !skipTickerNewsReset) {
        ctrl.currentMode = 'market-summary';
        ctrl.data.ticker = 'BUSINESS';
        ctrl.syncFiltersUI('market-summary');
        ctrl.renderMarketSummary();
        if (ctrl.container) {
            ctrl.container.classList.remove('news-open');
            const nm = ctrl.container.querySelector('.news-mode');
            if (nm) nm.classList.remove('narrative-mode');
        }
    }

    const centerPanelContent = document.getElementById('large-center-panel-content');
    if (centerPanelContent && centerPanelContent.object3D) {
        centerPanelContent.object3D.visible = true;
    }
}

async function onNewsGraphClick(shouldScroll = false) {
    if (typeof window.StockStormHideMainBlockHoverPopup === 'function') {
        window.StockStormHideMainBlockHoverPopup();
    }
    document.body.classList.add('news-graph-active');
    const categoryButtons = document.querySelectorAll('#main-block .filters-container .item');
    
    if (window.StockStorm3DInteraction && typeof window.StockStorm3DInteraction.resetGestureState === 'function') {
        window.StockStorm3DInteraction.resetGestureState();
    }

    _newsGraphActiveFilter = Array.from(categoryButtons).find(btn => btn.classList.contains('active')) || _newsGraphActiveFilter;
    
    categoryButtons.forEach(btn => btn.classList.remove('active'));

    const titleEl = document.querySelector('#main-container .title-and-date h2');
    if (titleEl) titleEl.innerText = 'News graph';

    const newsMenuBtn = document.getElementById('ss-news-btn');
    if (newsMenuBtn) newsMenuBtn.classList.add('active');

    const btn3dMenu = document.getElementById('ss-3d-chart-btn');
    if (btn3dMenu) btn3dMenu.classList.remove('active');

    if (document.body.dataset.isSearchMode === 'true') {
        document.dispatchEvent(new CustomEvent('close-search-screen'));
    }

    if (document.body.classList.contains('watchlist-mode')) {
        if (window.WatchlistApp && window.WatchlistApp.Manager && window.WatchlistApp.Manager.exitWatchlistMode) {
            window.WatchlistApp.Manager.exitWatchlistMode(false);
        }
    }

    if (window._newsGraphInstance) {
        window._newsGraphInstance.destroy();
        window._newsGraphInstance = null;
    }

    const centerPanelContent = document.getElementById('large-center-panel-content');
    if (centerPanelContent && centerPanelContent.object3D) {
        centerPanelContent.object3D.visible = false;
    }

    const existingComp = _getExistingTickerNewsComponent();
    if (existingComp) {
        existingComp.currentMode = 'market-summary';
        existingComp.syncFiltersUI('market-summary');
        existingComp.renderMarketSummary();
    }



    const elementsToHide = getNewsGraphTargetElements();
    
    elementsToHide.forEach(el => {
        if (el && el.dataset.newsGraphHidden !== 'true') {
            el.dataset.oldDisplay = el.style.display || '';
            el.dataset.newsGraphHidden = 'true';
            el.style.display = 'none';
        }
    });

    const titleAndDate = document.querySelector('.title-and-date');
    const filtersContainer = document.querySelector('.filters-container');
    if (titleAndDate && filtersContainer && filtersContainer.parentNode) {
        if (!_newsGraphOriginalTitleAndDateParent) {
            _newsGraphOriginalTitleAndDateParent = titleAndDate.parentNode;
            _newsGraphOriginalTitleAndDateNextSibling = titleAndDate.nextSibling;
        }
        filtersContainer.parentNode.insertBefore(titleAndDate, filtersContainer);
    }

    const mainBlock = document.getElementById('main-block');
    if (mainBlock) {
        let closeBtn = document.querySelector('#news-graph-close-btn');
        if (!closeBtn) {
            closeBtn = document.createElement('div');
            closeBtn.id = 'news-graph-close-btn';
            closeBtn.className = 'center-chart-close-button';
            
            const closeIcon = document.createElement('img');
            closeIcon.src = './desktop_assets/cross.svg';
            closeIcon.alt = 'Close';
            closeBtn.appendChild(closeIcon);
            
            closeBtn.addEventListener('click', () => {
                window.exitNewsGraphMode(true);
            });
            
            const contentRow = mainBlock.querySelector('.content-row');
            if (contentRow) {
                mainBlock.insertBefore(closeBtn, contentRow);
            } else {
                mainBlock.appendChild(closeBtn);
            }
        }
    }

    const legend = document.getElementById('news-graph-legend');
    if (legend) legend.style.display = 'none';

    const toolbar = document.getElementById('news-graph-toolbar');
    if (toolbar) toolbar.style.display = 'flex';

    const apiManager = await NewsProxyAPIManager.create();
    const data = await apiManager.fetchNarrativeTickerMap();
    if (!data) return;

    _newsGraphLastData = data;

    const overview = document.getElementById('news-graph-overview');
    if (overview) {
        let overviewText = 'No overview available.';
        if (data.overview && data.overview.market) {
            overviewText = data.overview.market;
        } else if (data.overview && data.overview.overview) {
            overviewText = data.overview.overview;
        } else if (typeof data.overview === 'string') {
            overviewText = data.overview;
        }
        overview.classList.add('is-market-overview');
        overview.innerHTML = `
            <h3 class="news-graph-overview-title">Overview</h3>
            <p class="news-graph-overview-text">${overviewText}</p>
        `;
    }

    const chartWrapper = document.querySelector('#main-block .chart-wrapper');
    if (!chartWrapper) return;

    _newsGraphOnNodeClick = (node) => {
        const ctrl = _getExistingTickerNewsComponent();
        if (ctrl) {
            ctrl.lastNarrativeData = data;
            ctrl._pendingRelatedTopics = _buildRelatedTopicsData(node, data);
        }

        updateOverviewPanel(node, data);

        const closeDetail = (ctrl) => {
            if (ctrl && ctrl.container) {
                ctrl.container.classList.remove('news-open');
                const nm = ctrl.container.querySelector('.news-mode');
                if (nm) nm.classList.remove('narrative-mode');
            }
        };

        if (ctrl) {
            ctrl.syncFiltersUI('none');
            closeDetail(ctrl);

            if (node) {
                if (window.NewsGraph.NARRATIVE_TYPES.has(node.type)) {
                    ctrl.openNarrativeDetail(node);
                } else {
                    ctrl.openTickerDetail(node, data);
                }
                const isMobilePortrait = document.documentElement.classList.contains('desktop-portrait-accepted') &&
                                         document.documentElement.classList.contains('desktop-portrait');
                if (isMobilePortrait) {
                    const overview = document.getElementById('news-graph-overview');
                    if (overview) {
                        overview.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }
                }
            } else {
                ctrl.currentMode = 'market-summary';
                ctrl.renderMarketSummary();
            }
        }
    };

    const viz = (_newsGraphActiveMode === '2d')
        ? new NewsGraph2DVisualizer(chartWrapper)
        : new NewsGraphVisualizer(chartWrapper);

    viz.onNodeClick = _newsGraphOnNodeClick;
    viz.mount(data);
    window._newsGraphInstance = viz;

    _setupNewsGraphToolbar(viz);

    if (shouldScroll) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }
}

async function switchNewsGraphMode(mode) {
    if (_newsGraphActiveMode === mode) return;
    _newsGraphActiveMode = mode;

    const btn3d = document.getElementById('ng-btn-3d');
    const btn2d = document.getElementById('ng-btn-2d');
    if (btn3d) btn3d.classList.toggle('active', mode === '3d');
    if (btn2d) btn2d.classList.toggle('active', mode === '2d');

    if (window._newsGraphInstance) {
        window._newsGraphInstance.destroy();
        window._newsGraphInstance = null;
    }

    const chartWrapper = document.querySelector('#main-block .chart-wrapper');
    if (!chartWrapper || !_newsGraphLastData) return;

    const viz = (mode === '2d')
        ? new NewsGraph2DVisualizer(chartWrapper)
        : new NewsGraphVisualizer(chartWrapper);

    viz.onNodeClick = _newsGraphOnNodeClick;
    viz.mount(_newsGraphLastData);
    window._newsGraphInstance = viz;

    _setupNewsGraphToolbar(viz);
}

function _setupNewsGraphToolbar(viz) {
    const btn3d     = document.getElementById('ng-btn-3d');
    const btn2d     = document.getElementById('ng-btn-2d');
    const legend    = document.getElementById('news-graph-legend');

    if (!viz || !viz._controls) return;

    const controls = viz._controls;

    const syncRotateBtn = (active) => {
        const btn = document.getElementById('ng-btn-rotate');
        if (!btn) return;
        btn.classList.toggle('active', active);
    };

    syncRotateBtn(controls.autoRotate);

    controls.onAutoRotateChange = (active) => {
        syncRotateBtn(active);
    };

    if (btn3d) {
        const newBtn3d = btn3d.cloneNode(true);
        btn3d.parentNode.replaceChild(newBtn3d, btn3d);
        newBtn3d.classList.toggle('active', _newsGraphActiveMode === '3d');
        newBtn3d.addEventListener('click', () => {
            switchNewsGraphMode('3d');
        });
    }
    if (btn2d) {
        const newBtn2d = btn2d.cloneNode(true);
        btn2d.parentNode.replaceChild(newBtn2d, btn2d);
        newBtn2d.classList.toggle('active', _newsGraphActiveMode === '2d');
        newBtn2d.addEventListener('click', () => {
            switchNewsGraphMode('2d');
        });
    }

    const btnGlobe = document.getElementById('ng-btn-globe');
    if (btnGlobe) {
        const newGlobeBtn = btnGlobe.cloneNode(true);
        btnGlobe.parentNode.replaceChild(newGlobeBtn, btnGlobe);

        if (_newsGraphActiveMode === '3d') {
            newGlobeBtn.style.display = 'flex';
            newGlobeBtn.classList.toggle('active', _newsGraphSphereVisible);
            if (viz && typeof viz.setOrbitSphereVisible === 'function') {
                viz.setOrbitSphereVisible(_newsGraphSphereVisible);
            }
        } else {
            newGlobeBtn.style.display = 'none';
        }

        newGlobeBtn.addEventListener('click', () => {
            _newsGraphSphereVisible = !_newsGraphSphereVisible;
            newGlobeBtn.classList.toggle('active', _newsGraphSphereVisible);
            if (viz && typeof viz.setOrbitSphereVisible === 'function') {
                viz.setOrbitSphereVisible(_newsGraphSphereVisible);
            }
            const tooltip = document.getElementById('narrative-source-tooltip');
            if (tooltip) tooltip.style.display = 'none';
        });

        newGlobeBtn.addEventListener('mouseenter', () => {
            let tooltip = document.getElementById('narrative-source-tooltip');
            if (!tooltip) {
                tooltip = document.createElement('div');
                tooltip.id = 'narrative-source-tooltip';
                document.body.appendChild(tooltip);
            }
            tooltip.textContent = 'Show border between narratives and tickers';
            tooltip.style.display = 'block';
            tooltip.style.width = '200px';

            const r = newGlobeBtn.getBoundingClientRect();
            let top = r.top - tooltip.offsetHeight - 8;
            if (top < 0) {
                top = r.bottom + 8;
            }
            let left = r.left + (r.width / 2) - 100;
            if (left < 10) left = 10;
            if (left + 200 > window.innerWidth) left = window.innerWidth - 210;

            tooltip.style.top = top + 'px';
            tooltip.style.left = left + 'px';
        });

        newGlobeBtn.addEventListener('mouseleave', () => {
            const tooltip = document.getElementById('narrative-source-tooltip');
            if (tooltip) {
                tooltip.style.display = 'none';
            }
        });
    }

    const btnRotate = document.getElementById('ng-btn-rotate');
    if (btnRotate) {
        const newRotateBtn = btnRotate.cloneNode(true);
        btnRotate.parentNode.replaceChild(newRotateBtn, btnRotate);
        newRotateBtn.classList.toggle('active', controls.autoRotate);

        newRotateBtn.addEventListener('click', () => {
            if (controls.autoRotate) {
                controls.disableAutoRotate();
            } else {
                controls.enableAutoRotate();
            }
        });
    }

    const btnLegend = document.getElementById('ng-btn-legend');
    if (btnLegend && legend) {
        const newLegendBtn = btnLegend.cloneNode(true);
        btnLegend.parentNode.replaceChild(newLegendBtn, btnLegend);

        newLegendBtn.addEventListener('click', () => {
            const isVisible = legend.style.display !== 'none';
            legend.style.display = isVisible ? 'none' : 'flex';
            newLegendBtn.classList.toggle('active', !isVisible);
            if (window._newsGraphInstance) {
                window._newsGraphInstance._adjustCameraToFit();
            }
        });
    }
}

function handleInteraction(elementId, actionName) {
    if (window.gtag) gtag('event', actionName, { event_category: 'News Graph', event_label: elementId });
}

function _getExistingTickerNewsComponent() {
    return window._tickerNewsInstance || null;
}


function _buildRelatedTopicsData(node, data) {
    if (!node || !data) return { entries: [], narrativeMap: {}, tickerMap: {} };

    const entries = window.NewsGraph.buildRelatedTopicsData(node, data);

    const narrativeMap = {};
    (data.narratives || []).forEach(n => { narrativeMap[n.id] = n; });
    const tickerMap = {};
    (data.tickers || []).forEach(t => { tickerMap[t.id] = t; });

    return { entries, narrativeMap, tickerMap, data };
}

function updateOverviewPanel(node, data) {
    const overview = document.getElementById('news-graph-overview');
    if (!overview) return;

    if (!node) {
        overview.classList.add('is-market-overview');
        let overviewText = 'No overview available.';
        if (data.overview && data.overview.market) {
            overviewText = data.overview.market;
        } else if (data.overview && data.overview.overview) {
            overviewText = data.overview.overview;
        } else if (typeof data.overview === 'string') {
            overviewText = data.overview;
        }
        overview.innerHTML = `
            <h3 class="news-graph-overview-title">Overview</h3>
            <p class="news-graph-overview-text">${overviewText}</p>
        `;
        return;
    }
}
window.NewsGraph = window.NewsGraph || {};
window.NewsGraph.updateOverviewPanel = updateOverviewPanel;

document.addEventListener('DOMContentLoaded', function () {
    const btn = document.getElementById('news-graph-btn');
    if (btn) {
        btn.addEventListener('click', () => onNewsGraphClick(true));
    }

    const newsMenuBtn = document.getElementById('ss-news-btn');
    if (newsMenuBtn) {
        newsMenuBtn.addEventListener('click', (e) => {
            e.preventDefault();
            onNewsGraphClick(false);
        });
    }
});
